module.exports = __webpack_public_path__ + "static/conceptSmall2-e99b1f54e95282603a74430c97b57207.jpg";